export default __webpack_public_path__ + "static/media/3.fd4e64a4.png";